module.exports = __webpack_public_path__ + "img/good.c501ee4a.png";